export default __webpack_public_path__ + "h10.png";